import brand from '@symbo.ls/brand/context.js'
import shared from '../shared/context.js'

export default [brand, shared]
